import { Text } from "@react-pdf/renderer";

export default function FaNum({ children }) {
  return (
    <Text style={{ fontFamily: "IRANSansX-FaNum" }}>
      {children}
    </Text>
  );
}
